import React from 'react'
import ImageNotAvailable from '../../../assets/image-not-available.png'
import CloseIcon from '../../../assets/Content-Icons/Svgs/close-circled.svg'
import { CCol, CFormCheck } from '@coreui/react'
import DownArrow from '../../../assets/down-arrow-black.svg'
import Icon8K from '../../../assets/videoQuality/8k-icon.png'
import Icon4K from '../../../assets/videoQuality/4k-icon.png'
import Icon2K from '../../../assets/videoQuality/2k-icon.png'
import Icon1080P from '../../../assets/videoQuality/1080p-icon.png'
import Icon720P from '../../../assets/videoQuality/720p-icon.png'
import Icon480P from '../../../assets/videoQuality/480p-icon.png'
import Icon360P from '../../../assets/videoQuality/360p-icon.png'
import PlayIcon from '../../../assets/Content-Icons/Svgs/play-circle.svg'
import EditIconBlack from '../../../assets/banner-edit.svg'
import { capitalize, isEmpty } from 'lodash'
import CustomImage from 'src/components/customImage/customImage'

const PreviewDetails = ({
  onClose = {},
  cardImage = '',
  playIconForVideo = false,
  headline = '',
  subHeadline = '',
  basicInfo = [],
  resolutions = '',
  width = '61%',
  disableAnimation = false,
  onEdit,
}) => {
  const ResolutionsIcon = {
    7680: Icon8K,
    3840: Icon4K,
    2048: Icon2K,
    1080: Icon1080P,
    720: Icon720P,
    480: Icon480P,
    360: Icon360P,
  }
  return (
    <div
      style={{ width: width, zIndex: '30' }}
      className={`preview-slider ${!disableAnimation && 'preview-slider-animation'} `}
    >
      <div
        className="w-50 p-3 d-flex flex-column justify-content-center align-items-start h-100 rounded-2"
        style={{
          background: '#ebe9e9',
        }}
      >
        <div className="mb-auto">
          <img src={CloseIcon} alt="" onClick={onClose} role="button" />
          {onEdit && (
            <img
              src={EditIconBlack}
              style={{ width: '24px', height: '24px' }}
              role="button"
              className="mx-3"
              onClick={onEdit}
            />
          )}
        </div>
        <div className="w-100 mb-auto relative">
          <CustomImage
            className="card-img-top"
            imageUrl={cardImage}
            loaderStyle={{ height: '100%' }}
            errorPlaceholder={ImageNotAvailable}
            alt={'Asset'}
            imgStyle={{ height: '100%', width: '100%' }}
          />
          {playIconForVideo && (
            <div className="play-icon">
              <img src={PlayIcon} alt="" />
            </div>
          )}
        </div>
      </div>
      <div
        className="w-50 scrollbar"
        style={{
          padding: '18px 23px 0 11px',
        }}
      >
        <div>
          <div className="text-right">
            <h5
              style={{
                color: '#191818',
                fontSize: '30px',
                fontWeight: '700',
              }}
            >
              {headline}
            </h5>
            <p style={{ fontSize: '14px' }}>{subHeadline}</p>
          </div>
          <div>
            <div
              className="d-flex justify-content-center align-items-center rounded-1 overflow-hidden"
              style={{ border: '0.5px solid #707070' }}
            >
              <CFormCheck
                className="preview-cformcheck"
                type="radio"
                id="flexRadioDefault1"
                label="Overview"
                value="overview"
                checked={true}
                onChange={() => null}
                disabled={false}
              />
              <CFormCheck
                className="preview-cformcheck mid-child"
                type="radio"
                id="flexRadioDefault2"
                label="Analytics"
                value="analytics"
                checked={false}
                onChange={() => null}
                disabled={true}
              />
              <CFormCheck
                className="preview-cformcheck"
                type="radio"
                id="flexRadioDefault3"
                label="More Information"
                value="information"
                checked={false}
                onChange={() => null}
                disabled={true}
              />
            </div>
            <div style={{ marginTop: '1.4vw' }}>
              {/* for data */}
              <h6 className="d-flex align-items-center gap-2">
                <span className="d-flex align-items-center">
                  <img src={DownArrow} alt="" />
                </span>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>Basic Information</span>
              </h6>
              <div className="tabular-div">
                {basicInfo.map((info, idx) => (
                  <div className="d-flex" key={idx}>
                    <p className="tabular-div-headings">{info.property}</p>
                    <p className="tabular-div-data">{info.value}</p>
                  </div>
                ))}
              </div>
            </div>
            {/* resolutions div */}
            <div style={{ marginTop: '1.4vw' }} className="w-75">
              <h6 className="d-flex align-items-center gap-2">
                <span className="d-flex align-items-center">
                  <img src={DownArrow} alt="" />
                </span>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>Resolution Available:</span>
              </h6>
              <div style={{ outline: '2px solid transparent' }} className="w-75 d-flex flex-wrap">
                {!isEmpty(resolutions) &&
                  Object.keys(resolutions).map((key, index) => {
                    return (
                      <div className=" w-50" key={index}>
                        <img
                          src={ResolutionsIcon[key]}
                          style={{
                            height: '0.87vw',
                            width: 'fit-content',
                            opacity: resolutions[key] < 100 ? '0.4' : '1',
                          }}
                          className="my-1"
                        />
                      </div>
                    )
                  })}
              </div>
            </div>
            {/* resolutions */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PreviewDetails

/*
 * All Styles for table like div ".tabular-div" is defined in the stylesheet *

  .tabular-div - make table like div structure for heading on the left side using the ".tabular-div-headings" class and data on the right side using the ".tabular-div-data" class
*/
